import React from 'lib/react';
import PropTypes from 'prop-types';
import { EVSnackbar } from 'lib/components';
import useMediaQuery from 'hooks/useMediaQuery';
import Banner from 'commonComponents/banner';
import ToastMessageStyles from './ToastMessageStyles';

function ToastMessage(props) {
  const {
    alertMsg, severity, position, open, onClose, autoHideDuration,
  } = props;
  const isMobile = useMediaQuery(640);

  const classes = ToastMessageStyles();

  if (isMobile) {
    return open ? (
      <Banner
        severity={severity}
        className={classes.toastMessageMobile}
        onClose={onClose}
        message={alertMsg}
      />
    ) : null;
  }

  return (
    <EVSnackbar
      anchorOrigin={position}
      open={open}
      autoHideDuration={autoHideDuration}
      className={classes.toastMessage}
    >
      <Banner
        severity={severity}
        className={classes.alertMsg}
        onClose={onClose}
        message={alertMsg}
      />
    </EVSnackbar>
  );
}

ToastMessage.propTypes = {
  alertMsg: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  position: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  autoHideDuration: PropTypes.number,
};

ToastMessage.defaultProps = {
  position: {
    vertical: 'top',
    horizontal: 'center',
  },
  autoHideDuration: 3000,
};

export default ToastMessage;
